import { rankingData } from '@/mocks/comics';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-10 md:py-14 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            人气榜单
          </h2>
          <p className="text-sm text-foreground-500">
            本周最受欢迎的漫画作品排行
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {rankingData.map((item) => (
            <a
              key={item.id}
              href="#ranking"
              className="group bg-background-50 rounded-xl border border-background-200 overflow-hidden hover:border-primary-300 transition-all cursor-pointer flex"
            >
              <div className="w-[100px] md:w-[110px] flex-shrink-0 relative overflow-hidden">
                <img
                  src={item.cover}
                  alt={`${item.title} - ${item.genre}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-2 left-2 w-6 h-6 rounded-full bg-primary-500 flex items-center justify-center">
                  <span className="text-xs font-bold text-white">{item.rank}</span>
                </div>
              </div>

              <div className="flex-1 p-3 md:p-4 flex flex-col justify-between">
                <div>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-1">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-0.5">{item.author}</p>
                  <span className="inline-block text-xs text-secondary-600 bg-secondary-50 px-2 py-0.5 rounded mt-2">
                    {item.genre}
                  </span>
                </div>
                <div className="flex items-center justify-between mt-2">
                  <span className="flex items-center gap-1 text-xs font-medium text-accent-600">
                    <i className="ri-star-fill text-xs"></i>
                    {item.rating}
                  </span>
                  <span className="text-xs text-foreground-500">{item.views}</span>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-3 lg:hidden">
          <div className="overflow-x-auto">
            <div className="flex gap-4 min-w-max">
              {rankingData.slice(4).map((item) => (
                <a
                  key={item.id}
                  href="#ranking"
                  className="flex-shrink-0 w-[280px] bg-background-50 rounded-xl border border-background-200 overflow-hidden hover:border-primary-300 transition-all cursor-pointer flex"
                >
                  <div className="w-[100px] flex-shrink-0 relative overflow-hidden">
                    <img
                      src={item.cover}
                      alt={`${item.title} - ${item.genre}`}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute top-2 left-2 w-6 h-6 rounded-full bg-primary-500 flex items-center justify-center">
                      <span className="text-xs font-bold text-white">{item.rank}</span>
                    </div>
                  </div>
                  <div className="flex-1 p-3 flex flex-col justify-between">
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-950 line-clamp-1">{item.title}</h3>
                      <p className="text-xs text-foreground-500">{item.author}</p>
                      <span className="inline-block text-xs text-secondary-600 bg-secondary-50 px-2 py-0.5 rounded mt-2">{item.genre}</span>
                    </div>
                    <div className="flex items-center justify-between mt-2">
                      <span className="flex items-center gap-1 text-xs font-medium text-accent-600">
                        <i className="ri-star-fill text-xs"></i>
                        {item.rating}
                      </span>
                      <span className="text-xs text-foreground-500">{item.views}</span>
                    </div>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}